var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernmentIdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.25 1H2.75C1.7835 1 1 1.7835 1 2.75V27.25C1 28.2165 1.7835 29 2.75 29H34.25C35.2165 29 36 28.2165 36 27.25V2.75C36 1.7835 35.2165 1 34.25 1Z",
    stroke: "#060606",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 15.875C13.3033 15.875 14.1935 15.5063 14.8499 14.8499C15.5062 14.1935 15.875 13.3033 15.875 12.375C15.875 11.4467 15.5062 10.5565 14.8499 9.90013C14.1935 9.24375 13.3033 8.875 12.375 8.875C11.4467 8.875 10.5565 9.24375 9.90013 9.90013C9.24375 10.5565 8.875 11.4467 8.875 12.375C8.875 13.3033 9.24375 14.1935 9.90013 14.8499C10.5565 15.5063 11.4467 15.875 12.375 15.875V15.875Z",
    stroke: "#060606",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 18.5H29M17.625 21.125C17.625 19.7326 17.0719 18.3973 16.0873 17.4127C15.1027 16.4281 13.7674 15.875 12.375 15.875C10.9826 15.875 9.64726 16.4281 8.66269 17.4127C7.67812 18.3973 7.125 19.7326 7.125 21.125H17.625ZM22 11.5H29H22Z",
    stroke: "#060606",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentIdIcon);
export default __webpack_public_path__ + "static/media/government-id--icon.f91a58267e76d1172d85c1033ce16037.svg";
export { ForwardRef as ReactComponent };